import {
  DataGridProProps,
  GridApi,
  GridColumnVisibilityModel,
  GridDensity,
  GridSortModel,
  GridValidRowModel,
  GridColDef,
} from '@mui/x-data-grid-pro';
import { MutableRefObject } from 'react';

import { DataGridConfig } from '../useDataGridConfig/useDataGridConfig.types';
import { Domain } from '~/common/types';

export interface DataGridConfigFormat {
  columnWidth: Record<string, number> | undefined;
  columnVisibility: GridColumnVisibilityModel | undefined;
  columnOrder: string[] | undefined;
  sort: GridSortModel | undefined;
  density: GridDensity;
}

export type LegacyConfigFormat = {
  name: 'string';
  width: number;
  hidden: boolean;
  sortBy?: 'asc' | 'desc';
}[];

export interface UseDataGridRemoteStateProps<R extends GridValidRowModel = any, V = any, F = V> {
  apiRef: MutableRefObject<GridApi>;
  config: DataGridConfig<R, V, F>;
  domain: Domain;
  skip?: boolean;
}

export type UseDataGridRemoteStateGridProps<R extends GridValidRowModel = any, V = any, F = V> = Pick<
  DataGridProProps<R>,
  | 'initialState'
  | 'columns'
  | 'columnGroupingModel'
  | 'density'
  | 'columnVisibilityModel'
  | 'sortModel'
  | 'onColumnWidthChange'
  | 'onColumnVisibilityModelChange'
  | 'onSortModelChange'
  | 'onColumnOrderChange'
> & {
  columns: GridColDef<R, V, F>[];
};

export interface UseDataGridRemoteStateResult<R extends GridValidRowModel = any> {
  loading?: boolean;
  gridProps: UseDataGridRemoteStateGridProps<R>;
  onDensityChange: (density: GridDensity) => void;
  onRemoteStateReset: () => void;
}

export enum UseDataGridRemoteStateUpdateReason {
  INITIAL,
  USER,
  REMOTE,
}

export interface UseDataGridRemoteStateState extends DataGridConfigFormat {
  updateReason: UseDataGridRemoteStateUpdateReason;
}
